/**
 * 접속 로그 API.
 * GET /admin/v1/user-access-logs — 관리자 조회 시 userType=ADMIN.
 */
import { apiClient } from '@/shared/api/http-client';
import { createApiPath } from '@/shared/api/endpoints';
import type { PageResponse } from '@/entities/admin-user/types';

export type UserAccessLogUserType = 'USER' | 'ADMIN';
export type UserAccessLogAccessType =
  | 'LOGIN'
  | 'TOKEN_REFRESH'
  | 'TOKEN_ACCESS';
export type UserAccessLogStatus = 'SUCCESS' | 'FAILED';

export interface UserAccessLog {
  id: number;
  userId: number | null;
  userType: UserAccessLogUserType;
  accessType: UserAccessLogAccessType;
  clientIp: string | null;
  userAgent: string | null;
  /** LOGIN 성공 로그에만 있을 수 있음. 참고 정보이며 위조 가능 */
  latitude: number | null;
  longitude: number | null;
  status: UserAccessLogStatus;
  failReason: string | null;
  accessedAt: string;
}

export interface UserAccessLogListParams {
  userId?: number;
  userType?: UserAccessLogUserType;
  accessType?: UserAccessLogAccessType;
  status?: UserAccessLogStatus;
  startDate?: string;
  endDate?: string;
  page?: number;
  size?: number;
}

export const userAccessLogService = {
  list: async (
    params: UserAccessLogListParams = {},
  ): Promise<PageResponse<UserAccessLog>> => {
    const query: Record<string, string | number> = {};
    if (params.userId !== undefined) query.userId = params.userId;
    if (params.userType !== undefined) query.userType = params.userType;
    if (params.accessType !== undefined) query.accessType = params.accessType;
    if (params.status !== undefined) query.status = params.status;
    if (params.startDate !== undefined) query.startDate = params.startDate;
    if (params.endDate !== undefined) query.endDate = params.endDate;
    if (params.page !== undefined) query.page = params.page;
    if (params.size !== undefined) query.size = params.size;

    const response = await apiClient.get(createApiPath.userAccessLogs.list(), {
      params: query,
    });
    return response.data;
  },
};

/** 위경도 쌍이 없으면 위치 미수집. 감사 기준은 clientIp */
export const formatAccessLogLocation = (
  latitude?: number | null,
  longitude?: number | null,
): string => {
  if (
    latitude == null ||
    longitude == null ||
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude)
  ) {
    return '위치 미수집';
  }
  return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
};
